import { FiExternalLink } from "react-icons/fi";
import FallbackImage from "newui/components/FallbackImage/FallbackImage";
import type { DisclaimerCompany } from "../../types/panel.type";

interface CompanyListingProps {
	companies: DisclaimerCompany[];
}

export const CompanyListing: React.FC<CompanyListingProps> = ({
	companies,
}) => {
	if (companies.length === 0) {
		return (
			<p
				className="text-sm text-gray-400 text-center py-4"
				data-testid="company-listing-empty"
			>
				No companies have been submitted.
			</p>
		);
	}

	return (
		<div
			className="border rounded-lg divide-y divide-gray-100 max-h-[300px] overflow-y-auto"
			data-testid="company-listing"
		>
			{companies.map((company) => (
				<div
					key={company.id}
					className="flex items-center justify-between px-4 py-2.5"
					data-testid={`company-listing-item-${company.id}`}
				>
					<div className="flex items-center gap-3">
						<FallbackImage
							src={company.logo_url || ""}
							alt={company.name}
							className="h-8 w-8 rounded-full object-cover border border-gray-100"
						/>
						<span className="text-sm text-gray-700">{company.name}</span>
					</div>
					<button
						type="button"
						onClick={() => {
							if (company.id > 0) {
								window.open(`/company/${company.id}`, "_blank", "noopener");
							}
						}}
						className="inline-flex items-center gap-1 text-xs font-medium text-[#0031DD] hover:underline"
						data-testid={`company-listing-view-${company.id}`}
						title={`View ${company.name} profile`}
					>
						View Profile
						<FiExternalLink className="size-3" />
					</button>
				</div>
			))}
		</div>
	);
};
